import { render, staticRenderFns } from "./VhostsTable.vue?vue&type=template&id=649b5880&"
import script from "./VhostsTable.vue?vue&type=script&lang=js&"
export * from "./VhostsTable.vue?vue&type=script&lang=js&"
import style0 from "./VhostsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports